module.exports = __webpack_public_path__ + "img/dashboard-hero-bg.156c768c.png";